export default __webpack_public_path__ + "static/media/family-picture-placeholder.415326d7.svg";